// @flow

import styled from 'styled-components';

export const Checkbox = styled.input.attrs({ type: 'checkbox' })``;
